require('dmuploader');

const UploadDragAndDrop = {
  uploadErrorAlert: $('.alert.uploader-error'),
  maxFileSize: 10485760,
  maxFiles: 1,
  dataType: 'json',
  fileName: 'filedata',
  extFilter: 'pdf;doc;docx',
  trackBeforeUploadAction: null,
  extraData: {},
  initiateUploadFromSidebarSiteNav: null,
  isSupportedDevice: () => {
    // Disable for some devices
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return false;
    }
    return true;
  },
  isIOSDevice: () => (
    /iPhone|iPad|iPod/i.test(navigator.userAgent)
  ),
  setUrl: (url) => {
    // Hacking around since our outdated dmUploader version won't allow us
    // to update the upload endpoint from its api
    // https://github.com/danielm/uploader/issues/78
    // https://stackoverflow.com/questions/28224165/how-to-update-a-params-on-jquery-plugin-after-is-set
    const dmUploadSettings = $('#dropzoneUploader').dmUploader().data().dmUploader.settings;
    dmUploadSettings.url = url;
  },
  setUserParams: () => {
    const dmUploadSettings = $('#dropzoneUploader').dmUploader().data().dmUploader.settings;
    dmUploadSettings.extraData = window.Upload.getUserParams();
  },
  deactivate: (message) => {
    console.log(`Upload plugin can't be initialized: ${message}`);
    $('#dropzoneUploader')
      .find('.uploader-area, .uploader-devider')
      .hide()
      .end()
      .parent()
      .css('margin-top', '60px');
  },

  onFallbackMode: message => UploadDragAndDrop.deactivate(message),
  onFileExtError: (file) => {
    UploadDragAndDrop.uploadErrorAlert.html(`File extension of ${file.name} should be .pdf`).show();
    $('#dropzoneUploader .uploader-area').removeClass('is-dragover');
  },
  onFileSizeError: (file) => {
    UploadDragAndDrop.uploadErrorAlert.html(`File size of  ${file.name} exceeds the limit (10 Mb)`).show();
    $('#dropzoneUploader .uploader-area').removeClass('is-dragover');
  },
  onBeforeUpload: () => {
    if (UploadDragAndDrop.uploadErrorAlert.css('display') !== 'none') {
      UploadDragAndDrop.uploadErrorAlert.hide();
    }
    $('#dropzoneUploader .uploader-area').removeClass('is-dragover');

    if (window.Upload.type === 'rearrangeOptIn') {
      window.handleRearrangeOptInUploadStart();
    } else if (UploadDragAndDrop.initiateUploadFromSidebarSiteNav) {
      UploadDragAndDrop.initiateUploadFromSidebarSiteNav();
    } else {
      window.Upload.uploadLoading('start');
    }

    // Currently the upload section on the my documents page uses react ReactCompatibility
    // to disable the default tracking below. Some pages with drag and drop functionality
    // do not currently have access to ReactCompatibility, once this is enabled on all drag
    // and drop pages in future tickets, we will be able to remove the first check below.
    const defaultTrackingDisabled = window.ReactCompatibility &&
      !window.ReactCompatibility.getDefaultDragAndDropDisabled();
    if (!defaultTrackingDisabled && UploadDragAndDrop.trackBeforeUploadAction) {
      window._track('Drop PDF Upload', UploadDragAndDrop.trackBeforeUploadAction);
    }
  },
  onUploadSuccess: (id, responseJSON) => {
    // The response format differs depending on which endpoint we call. Account for both.
    if (responseJSON.status === 'success') {
      if (window.COOKIE.get('userid') && window.COOKIE.get('userToken')) {
        let categoryToTrack = 'Document Created';
        let actionToTrack = 'custom-uploaded-doc';
        const isCustomTemplateUpload = window.Upload.type === 'custom-template';
        const isUploadedFromMyTemplatesPage = window.location.pathname.indexOf('myFillableFields.php') > 0;

        if (isCustomTemplateUpload && isUploadedFromMyTemplatesPage) {
          categoryToTrack = 'Drop Zone Upload | Template Tab';
          actionToTrack = 'My Templates';
        }
        window._track(categoryToTrack, actionToTrack);
      }

      // Handle IE pathname
      let currentPath = window.location.pathname;
      currentPath = currentPath.replace('/', '');
      let redirectURL;

      if (window.Upload.type === 'rearrange') {
        const initialPdfLink = encodeURIComponent(responseJSON.data.document.pdf_link);
        redirectURL = `/free-write/edit-pages.php?initial_pdf_link=${initialPdfLink}`;
      } else if (window.Upload.type === 'custom-template') {
        const customTemplateData = responseJSON.data.custom_template;
        const documentType = customTemplateData.document_type;
        if (currentPath === 'sem/edit-pdf' && !window.COOKIE.get('userid')) {
          const documentName = customTemplateData.name;
          redirectURL = `/newAccount-Template?documentType=${documentType}&document_name=${documentName}`;
        } else {
          redirectURL = `/self-serve-builder?documentType=${documentType}`;
        }
      } else {
        const documentType = window.Upload.getDocumentType(responseJSON);
        redirectURL = window.Upload.getEditLink(documentType);
      }
      // For split test https://app.optimizely.com/v2/projects/48120048/experiments/11944892507
      if (window.Upload.type === 'rearrangeOptIn') {
        let uploadedDocumentData = null;
        try {
          uploadedDocumentData = responseJSON.data.document;
        } catch (e) {
          window.Upload.handleError(e);
          return;
        }

        window.handleRearrangeOptIn(uploadedDocumentData);
      } else if (window.location !== window.parent.location) {
        window.parent.location.replace(redirectURL);
      } else {
        window.location.replace(redirectURL);
      }
    } else {
      if (responseJSON.status === 'error') {
        window.Upload.handleError(responseJSON.message);
        return;
      }
      window.Upload.handleError('Unexpected Upload Error');
    }
  },
  onUploadError: (id, message) => {
    UploadDragAndDrop.uploadErrorAlert.html(`Error trying to upload #${id}: ${message}`).show();
    window.Upload.uploadLoading('stop');
    window.Upload.handleError('Error on drag and drop upload');
  },
  initialize: (url, initiateUploadFromSidebarSiteNav = null) => {
    if (initiateUploadFromSidebarSiteNav) {
      UploadDragAndDrop.initiateUploadFromSidebarSiteNav = initiateUploadFromSidebarSiteNav;
    }

    // Let's only activate the mobile version of the upload button if it exists on the page,
    // otherwise let's keep the current upload button
    // Multiple calls to initialize will NOT update the url once set
    // use setUrl for this purpose
    if (UploadDragAndDrop.isSupportedDevice() || !document.getElementById('uploadPDFLargeMobile')) {
      UploadDragAndDrop.url = url;
      if (window.Upload.type === 'custom-template') {
        UploadDragAndDrop.extraData = window.Upload.getUserParams();
      }
      $('#dropzoneUploader').dmUploader(UploadDragAndDrop);
    } else {
      UploadDragAndDrop.deactivate();

      const mobileUploadButton = document.getElementById('uploadPDFLargeMobile');
      if (mobileUploadButton) {
        mobileUploadButton.classList.remove('is-hidden');
      }
    }
  },
};

module.exports = UploadDragAndDrop;



// WEBPACK FOOTER //
// ./src-assets/js/upload-drag-and-drop.js